import moment from "moment";

export const DAYS = [
    { key: "Mon", label: "월" },
    { key: "Tue", label: "화" },
    { key: "Wed", label: "수" },
    { key: "Thu", label: "목" },
    { key: "Fri", label: "금" },
    { key: "Sat", label: "토" },
    { key: "Sun", label: "일" },
];

export const DAY_PRESETS = [
    { label: "평일", keys: ["Mon", "Tue", "Wed", "Thu", "Fri"] },
    { label: "주말", keys: ["Sat", "Sun"] },
    { label: "매일", keys: DAYS.map((d) => d.key) },
];

/** repeatConfig({Mon:"Y",...}) → 선택된 요일 key 배열 (월~일 순) */
export function selectedDayKeys(repeatConfig) {
    if (!repeatConfig || typeof repeatConfig !== "object") return [];
    return DAYS.filter((d) => !!repeatConfig[d.key]).map((d) => d.key);
}

/** 선택 요일을 "월–금", "토·일", "월·수·금" 형태로 요약 */
export function summarizeDays(repeatConfig) {
    const keys = selectedDayKeys(repeatConfig);
    if (keys.length === 0) return "";
    if (keys.length === 7) return "매일";

    const idx = keys.map((k) => DAYS.findIndex((d) => d.key === k));
    const parts = [];
    let start = 0;
    for (let i = 1; i <= idx.length; i++) {
        if (i === idx.length || idx[i] !== idx[i - 1] + 1) {
            const run = idx.slice(start, i);
            if (run.length >= 3) parts.push(`${DAYS[run[0]].label}–${DAYS[run[run.length - 1]].label}`);
            else run.forEach((n) => parts.push(DAYS[n].label));
            start = i;
        }
    }
    return parts.join("·");
}

/** "HH:mm[:ss]" → "HH:mm" */
export function hhmm(value) {
    if (!value) return "";
    return String(value).slice(0, 5);
}

/** "HH:mm" → 하루(0~24h) 중 위치(%) */
export function timelinePercent(value) {
    const t = hhmm(value);
    if (!/^\d{1,2}:\d{2}$/.test(t)) return 0;
    const [h, m] = t.split(":").map(Number);
    return Math.min(100, Math.max(0, ((h * 60 + m) / 1440) * 100));
}

export function formatDate(value, format = "YYYY-MM-DD") {
    return value ? moment(value).format(format) : "-";
}

export function zoneName(store, zoneIdx) {
    if (zoneIdx === null || zoneIdx === undefined || zoneIdx === "") return "전체";
    const zone = (store.state.zoneInfo || []).find((z) => z.value == zoneIdx);
    return zone ? zone.text : "-";
}

export function equipTypeName(store, equipType) {
    const type = (store.state.transEquipType || []).find((t) => t.value == equipType);
    return type ? type.text : equipType;
}

/** 실행 결과 코드(resultCode) → success | fail | etc */
export function classifyResult(code) {
    const c = String(code ?? "");
    if (/succ|^ok$|done|complete|^0000$/i.test(c)) return "success";
    if (/fail|error|timeout|^9999$/i.test(c)) return "fail";
    return "etc";
}

/** 이력/예외일 날짜 문자열의 요일(한글) */
export function weekdayLabel(dateStr) {
    if (!dateStr) return "";
    const d = moment(dateStr);
    if (!d.isValid()) return "";
    return ["일", "월", "화", "수", "목", "금", "토"][d.day()];
}

/** 예외일 배열 → { "YYYY-MM-DD": item } (사용 중인 예외일만) */
export function activeExceptMap(exceptConfig) {
    const map = {};
    (exceptConfig || []).forEach((item) => {
        if (item.enabled === "N" || item.enabled === false) return;
        map[moment(item.exceptDt).format("YYYY-MM-DD")] = item;
    });
    return map;
}
